import React, { useState } from 'react';
import './InfoTooltip.css';

interface InfoTooltipProps {
    text: string;
    className?: string;
}

const InfoTooltip: React.FC<InfoTooltipProps> = ({ text, className = '' }) => {
    const [isVisible, setIsVisible] = useState(false);

    return (
        <div 
            className={`info-tooltip-container ${className}`}
            onMouseEnter={() => setIsVisible(true)}
            onMouseLeave={() => setIsVisible(false)}
        >
            <div className="info-icon">
                <svg 
                    width="14" 
                    height="14" 
                    viewBox="0 0 24 24" 
                    fill="none" 
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <circle cx="12" cy="12" r="10" stroke="#666" strokeWidth="2" fill="#f0f0f0"/>
                    <path d="M12 16v-4" stroke="#666" strokeWidth="2" strokeLinecap="round"/>
                    <path d="M12 8h.01" stroke="#666" strokeWidth="2" strokeLinecap="round"/>
                </svg>
            </div>
            {isVisible && (
                <div className="tooltip-content">
                    {text}
                </div>
            )}
        </div>
    );
};

export default InfoTooltip;
